export default __webpack_public_path__ + "static/media/Factory4.7c8bf858.jpg";